module.exports = __webpack_public_path__ + "assets-cabinet/img/phone.3036e81c.svg";